(function () {
    'use strict';

    angular
        .module('app')
        .controller('SegmentsEditController', SegmentsEditController);

    SegmentsEditController.$inject = ['debug', '$stateParams', 'i18n', 'API', '$q',];

    function SegmentsEditController(debug, $stateParams, i18n, API, $q) {
        var vm = this;
        vm.tag = $stateParams.tag;
        vm.isSaving = false;
        vm.save = save;
        vm.addSubject = addSubject;
        vm.removeSubject = removeSubject;
        vm.segment = {};
        vm.availableSubjects = [];
        vm.subjects = [];
        vm.loadingState = {
            segmentIsLoading: false
        };

        activate();

        function activate() {
            loadSegment();
        }

        function loadSegment() {
            vm.loadingState.segmentIsLoading = true;

            var promises = [
                API.Segment.get({ id: vm.tag, expand: 'subjects' }).$promise,
                API.Subject.search({ 'per-page': -1 }).$promise
            ];

            $q.all(promises).then(function (responses) {
                vm.segment = responses[0];

                if(responses[1].items && responses[1].items.length){
                    vm.availableSubjects = responses[1].items;
                }

                if(vm.segment.subjects.length){
                    vm.subjects = vm.segment.subjects;
                } else {
                    addSubject();
                }

                vm.loadingState.segmentIsLoading = false;
            }, console.error);
        }

        function addSubject() {
            vm.subjects.push({ id: '' });
        }

        function removeSubject(index){
            vm.subjects.splice(index, 1);
        }

        function save() {
            if (vm.isSaving) {
                return;
            }

            vm.isSaving = true;

            var subjectIds = [];
            angular.forEach(vm.subjects, function(subject){
                if(parseInt(subject.id, 10) > 0) {
                    subjectIds.push(parseInt(subject.id, 10));
                }
            });

            if(subjectIds.length){
                vm.segment.subject_ids = subjectIds;
            }

            console.log(API.Segment, API.Segment.update);

            API.Segment.update({}, vm.segment).$promise.then(function (response) {
                if (response.tag) {
                    angular.extend(vm.segment, response);
                    window.toast({ message: i18n.get('SAVED'), autoRemoveTime: 5000, type: 'success' });
                    loadSegment();
                }
            }, function () {
            })
            .finally(function() {
                vm.isSaving = false;
            });
        }
    }
})();